var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2437)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72481 38.6702C24.6821 58.0009 52.978 52.7202 75.4755 38.5113C75.8624 38.268 76.3752 38.3828 76.6185 38.7697C76.8618 39.1566 76.747 39.6693 76.3601 39.9126C53.2333 54.5207 24.1449 59.7598 2.60074 39.8871C2.26448 39.5782 2.24375 39.0542 2.55429 38.7166C2.86321 38.3803 3.38723 38.3596 3.72481 38.6702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4958 39.4789C74.0416 39.5506 72.2176 39.6607 72.0103 39.6672C66.3911 39.8423 61.0459 39.1363 55.6188 37.6247C55.1782 37.5026 54.9201 37.0442 55.0422 36.6036C55.1644 36.163 55.6227 35.9049 56.0633 36.027C61.3255 37.4945 66.5092 38.1806 71.96 38.0101C72.2777 38.0004 76.3778 37.7503 77.2107 37.762C77.5523 37.7652 77.7446 37.8732 77.7876 37.903C78.0217 38.0525 78.1113 38.2462 78.1508 38.408C78.194 38.5909 78.1917 38.9103 77.9652 39.2553C77.7266 39.6153 77.0516 40.2372 76.8939 40.408C74.5216 42.991 71.6488 45.6672 69.4991 48.678C67.4488 51.5491 66.0546 54.7285 66.5268 58.455C66.5847 58.9086 66.2615 59.3237 65.8079 59.3816C65.3543 59.4395 64.9392 59.1164 64.8813 58.6627C64.3543 54.4963 65.8583 50.9239 68.1492 47.7153C70.2866 44.7225 73.1159 42.0493 75.4958 39.4789Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-0.777146 0.62932 0.62932 0.777146 47.1913 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow04);
export default __webpack_public_path__ + "static/media/Arrow_04.6ed5d5a393428a905eacac86f07486e6.svg";
export { ForwardRef as ReactComponent };